// removed by extract-text-webpack-plugin
module.exports = {"wrap":"_3r5zcCn3hsPbyLyu12TXtL","container":"_1QLx0jrvau8VIgQ_p2THfh","logo":"_2Dr-Z-tCl2fPZZg7QIfhzu","header":"LvujtBHcAFf0OJojsdrvK","desktop":"_2VqAx7V1aLjSuBoXuQTjhD","mobile":"uZ3BxMD1OBYbrcem1DOsm","poweredBy":"lE213SHOwTKAeHfNFIe1o"};


//////////////////
// WEBPACK FOOTER
// ./src/client/Layouts/AuthLayout.css
// module id = 1120
// module chunks = 58